import { Parser } from "expr-eval-fork";
import nerdamer from "nerdamer/all.min";
import BookFiltersStore from "../Flux/Stores/BookFiltersStore";
import AppSDK from "@growthos/ui-app-sdk";

const MediaMath = {
	getRateLineItem: (rateType) => {
		/* Filter through our Media Math called on App Load to retrieve proper formulas */
		const rates = BookFiltersStore.getFormulas();
		const rateTypeName = rateType.label || rateType;
		const formulaToCalc = rates.filter((rate) => {
			if ([rate.RateTypeName.toUpperCase(), rate.RateTypeCode.toUpperCase()].includes(rateTypeName.toUpperCase())) {
				return rate;
			}
		});

		return formulaToCalc;
	},

	fireConversionMath: (name, value, self, update, dataConfig, formEl) => {
		let isDraft = false;
		if (formEl === "edit_package") {
			if (self.props.packageData.IsDraft === "True" && self.state.formData.Cost.value) {
				isDraft = true;
			}
		}
		// Separate functions for draft state packages and non-draft state
		if (isDraft === false) {
			const rateType = self.state.formData.RateType?.value;
			/* Break into seperate function */
			if (rateType) {
				const formulaToCalc = MediaMath.getRateLineItem(rateType);
				const mediaMathFormula = Object.keys(formulaToCalc).length === 0 ? "0" : formulaToCalc[0].Formula;
				/* =========================== */
				// console.log("mediaMathFormula", mediaMathFormula);
				MediaMath.triggerUpdateCalculatedValue(mediaMathFormula, self, update, dataConfig, formEl);
				// switch (name) {
				// 	case 'RateType':
				// 		MediaMath.triggerUpdateTotalCost(mediaMathFormula, self, update, dataConfig, formEl);
				// 		break;
				// 	case 'PlannedUnits':
				// 		MediaMath.triggerUpdateTotalCost(mediaMathFormula, self, update, dataConfig, formEl);
				// 		break;
				// 	case 'Rate':
				// 		MediaMath.triggerUpdateTotalCost(mediaMathFormula, self, update, dataConfig, formEl);
				// 		break;
				// 	case 'Cost':
				// 		MediaMath.triggerUpdateTotalCost(mediaMathFormula, self, update, dataConfig, formEl);
				// 		break;
				// 	default:
				// 		break;
				// }
			} else {
				// MediaMath.resetAllRateFields(update, formEl, self);
			}
		} else {
			const rateType = self.state.formData.RateType.value;
			const rate = self.state.formData.Rate.value;
			const cost = self.state.formData.Cost.value;
			if (rateType && rate) {
				if (parseFloat(rate) * 1 !== 0) {
					const formulaToCalc = MediaMath.getRateLineItem(rateType);
					let mediaMathFormula = Object.keys(formulaToCalc).length === 0 ? "0" : formulaToCalc[0].Formula + " = Cost";
					/* =========================== */
					if (mediaMathFormula.includes("PlannedUnits")) {
						const plannedUnitElem = document.querySelector(`#${formEl} [name="PlannedUnits"]`);
						if (plannedUnitElem !== null) {
							mediaMathFormula = mediaMathFormula.replace("Cost", cost.toString());
							mediaMathFormula = mediaMathFormula.replace("Rate", rate.toString());
							let plannedUnits = nerdamer.solve(mediaMathFormula, "PlannedUnits");
							plannedUnits = eval(plannedUnits.toString().replace("[", "").replace("]", ""));
							if (!isNaN(plannedUnits)) {
								plannedUnits = Math.round(plannedUnits);
							}
							const dataBucket = plannedUnitElem.attributes["data-config"];
							update(dataBucket.value, "PlannedUnits", plannedUnits, plannedUnitElem.id, "Integer", true, formEl, self);
						}
					} else {
						const plannedUnitElem = document.querySelector(`#${formEl} [name="PlannedUnits"]`);
						if (plannedUnitElem !== null) {
							const dataBucket = plannedUnitElem.attributes["data-config"];
							update(dataBucket.value, "PlannedUnits", 0, plannedUnitElem.id, "Integer", true, formEl, self);
						}
					}
				}
			}
		}
	},

	resetTotalCost: (update, formEl, self) => {
		let isDraft = false;
		if (formEl === "edit_package") {
			if (self.props.packageData.IsDraft === "True" && self.state.formData.Cost.value) {
				isDraft = true;
			}
		}
		const costElem = document.querySelector(`#${formEl} [name="Cost"]`);
		if (costElem !== null && isDraft === false) {
			const dataConfig = costElem.attributes["data-config"].value;
			update(dataConfig, "Cost", 0, costElem.id, "Currency", true, formEl, self);
		} else {
			const plannedUnitElem = document.querySelector(`#${formEl} [name="PlannedUnits"]`);
			if (plannedUnitElem !== null) {
				const dataBucket = plannedUnitElem.attributes["data-config"];
				update(dataBucket.value, "PlannedUnits", 0, plannedUnitElem.id, "Integer", true, formEl, self);
			}
		}
	},

	resetAllRateFields: (update, formEl, self) => {
		let isDraft = false;
		if (formEl === "edit_package") {
			if (self.props.packageData.IsDraft === "True" && self.state.formData.Cost.value) {
				isDraft = true;
			}
		}
		const costElem = document.querySelector(`#${formEl} [name="Cost"]`);
		const plannedUnitsElem = document.querySelector(`#${formEl} [name="PlannedUnits"]`);
		const rateElem = document.querySelector(`#${formEl} [name="Rate"]`);
		if (costElem && plannedUnitsElem && rateElem && isDraft === false) {
			const dataConfig = costElem.attributes["data-config"].value;
			setTimeout(() => {
				update(dataConfig, "Cost", 0, costElem.id, "Currency", true, formEl, self);
			}, 0);
			setTimeout(() => {
				update(dataConfig, "Rate", 0, rateElem.id, "Currency", true, formEl, self);
			}, 100);
			setTimeout(() => {
				update(dataConfig, "PlannedUnits", 0, plannedUnitsElem.id, "Integer", true, formEl, self);
			}, 200);
		} else {
			const plannedUnitElem = document.querySelector(`#${formEl} [name="PlannedUnits"]`);
			if (plannedUnitElem !== null) {
				const dataBucket = plannedUnitElem.attributes["data-config"];
				update(dataBucket.value, "PlannedUnits", 0, plannedUnitElem.id, "Integer", true, formEl, self);
			}
		}
	},

	triggerUpdateCalculatedValue: (mediaMathFormula, self, update, dataConfig, formEl) => {
		if (self.state.valueToCalculate === "unitRate") {
			if (mediaMathFormula === "0") {
				const costElem = document.querySelector(`#${formEl} [name="Cost"]`);
				if (costElem) {
					const dataConfig = costElem.attributes["data-config"].value;
					update(dataConfig, "Cost", 0, costElem.id, "Currency", true, formEl, self);
				}
			} else if (self.state.formData.PlannedUnits.value && self.state.formData.Cost.value) {
				if (mediaMathFormula.includes("Rate")) {
					const formulaWithValues = (mediaMathFormula + " = Cost")
						.replace("PlannedUnits", parseFloat(self.state.formData.PlannedUnits.value).toString())
						.replace("Cost", self.state.formData.Cost.value.toString());
					try {
						const answer = nerdamer.solve(formulaWithValues, "Rate");
						const num = eval(answer.toString())[0];
						const rateElem = document.querySelector(`#${formEl} [name="Rate"]`);
						if (rateElem) {
							const dataConfig = rateElem.attributes["data-config"].value;
							update(dataConfig, "Rate", eval(num), rateElem.id, "Currency", true, formEl, self);
						}
					} catch (error) {
						console.log("Calculation error");
					}
				}
			}
		} else if (self.state.valueToCalculate === "plannedUnits") {
			if (mediaMathFormula === "0") {
				const costElem = document.querySelector(`#${formEl} [name="Cost"]`);
				if (costElem) {
					const dataConfig = costElem.attributes["data-config"].value;
					update(dataConfig, "Cost", 0, costElem.id, "Currency", true, formEl, self);
				}
			}
			if (self.state.formData?.Rate?.value && self.state.formData.Cost?.value) {
				if (mediaMathFormula.includes("PlannedUnits")) {
					const formulaWithValues = (mediaMathFormula + " = Cost")
						.replace("Rate", parseFloat(self.state.formData.Rate.value).toString())
						.replace("Cost", self.state.formData.Cost.value.toString());
					try {
						const answer = nerdamer.solve(formulaWithValues, "PlannedUnits");
						const plannedUnitsElem = document.querySelector(`#${formEl} [name="PlannedUnits"]`);
						if (plannedUnitsElem) {
							/*  Round up or down with .5 as the pivot point. 
								(totalCost, unitRate) => unrounded => rounded
								(10, 3) => 3.33 => 3
								(10, 4) => 2.5 => 3	
								(10, 6) => 1.66 => 2
							*/

							const dataConfig = plannedUnitsElem.attributes["data-config"].value;
							const num = eval(answer.toString())[0];
							update(dataConfig, "PlannedUnits", num - parseInt(num) >= 0.5 ? Math.ceil(num) : Math.floor(num), plannedUnitsElem.id, "Integer", true, formEl, self);
						}
					} catch (error) {
						console.log("Calculation error");
					}
				}
			}
		} else if (self.state.valueToCalculate === "plannedTotalCost") {
			if (mediaMathFormula === "0") {
				const costElem = document.querySelector(`#${formEl} [name="Cost"]`);
				if (costElem) {
					const dataConfig = costElem.attributes["data-config"].value;
					update(dataConfig, "Cost", 0, costElem.id, "Currency", true, formEl, self);
				}
			}
			if (self.state.formData.PlannedUnits.value && self.state.formData?.Rate?.value) {
				const formulaWithValues =
					mediaMathFormula
						.replace("Rate", parseFloat(self.state.formData.Rate.value).toString())
						.replace("PlannedUnits", self.state.formData.PlannedUnits.value.toString()) + " = Cost";
				try {
					const answer = nerdamer.solve(formulaWithValues, "Cost");
					const costElem = document.querySelector(`#${formEl} [name="Cost"]`);
					if (costElem) {
						const dataConfig = costElem.attributes["data-config"].value;
						const num = eval(answer.toString())[0];
						update(dataConfig, "Cost", eval(num), costElem.id, "Currency", true, formEl, self);
					}
				} catch (error) {
					console.log("Calculation error");
				}
			}
		}
	},

	triggerUpdateTotalCost: (mediaMathFormula, self, update, dataConfig, formEl) => {
		const costElem = document.querySelector(`#${formEl} [name="Cost"]`);
		if (costElem !== null) {
			const dataValues = {
				PlannedUnits: self.state.formData.PlannedUnits,
				Rate: self.state.formData.Rate
			};
			const total = MediaMath.mediaMathCalc(mediaMathFormula, dataValues);
			const dataBucket = costElem.attributes.dataconfig;
			update(dataBucket.value, "Cost", total, costElem.id, "Currency", true, formEl, self);
		}
	},

	mediaMathCalc: (mediaMathFormula, dataValues) => {
		const totalCost = MediaMath.mathParser(mediaMathFormula, {
			PlannedUnits: dataValues.PlannedUnits ? Number(dataValues.PlannedUnits.value) : 0,
			Rate: dataValues.Rate ? Number(dataValues.Rate.value) : 0
		});
		return totalCost || 0;
	},

	mediaMathWrapper: (name, value, self, update, dataConfig, formEl) => {
		if (value) {
			if (name === "PlannedUnits" || name === "Rate" || name === "RateType" || name === "Cost") {
				// Rate Type is required before any calculations can happen
				if (self.state.formData.RateType) {
					MediaMath.fireConversionMath(name, value, self, update, dataConfig, formEl);
				}
			}
		} else if (name === "RateType") {
			MediaMath.resetAllRateFields(update, formEl, self);
		}
	},

	sheetCalculatePlannedUnits: (dataValues) => {
		if (dataValues.RateType.value && dataValues.Rate.value) {
			if (parseFloat(dataValues.Rate.value) * 1 !== 0) {
				const rates = BookFiltersStore.getFormulas();
				const formulaToCalc = rates.filter((rate) => {
					if ([rate.RateTypeName.toUpperCase(), rate.RateTypeCode.toUpperCase()].includes(dataValues.RateType.value.toUpperCase())) {
						return rate;
					}
				});
				let mediaMathFormula = Object.keys(formulaToCalc).length === 0 ? "0" : formulaToCalc[0].Formula + " = Cost";
				if (mediaMathFormula.includes("PlannedUnits")) {
					mediaMathFormula = mediaMathFormula.replace("Cost", dataValues.Cost.value.toString());
					mediaMathFormula = mediaMathFormula.replace("Rate", dataValues.Rate.value.toString());
					let plannedUnits = nerdamer.solve(mediaMathFormula, "PlannedUnits");
					plannedUnits = eval(plannedUnits.toString().replace("[", "").replace("]", ""));
					if (!isNaN(plannedUnits)) {
						plannedUnits = Math.round(plannedUnits);
					}
					return plannedUnits;
				}
				return 0;
			}
			return 0;
		}
	},

	plannedUnitsSheetWrapper: (name, value, data) => {
		if (value) {
			let dataValues;
			switch (name) {
				case "RateType":
					dataValues = {
						RateType: { value },
						Cost: { value: data.Cost },
						Rate: { value: data.Rate }
					};
					return MediaMath.sheetCalculatePlannedUnits(dataValues);
				case "Rate":
					dataValues = {
						RateType: { value: data.RateType },
						Cost: { value: data.Cost },
						Rate: { value }
					};
					return MediaMath.sheetCalculatePlannedUnits(dataValues);
				default:
					return data.PlannedUnits;
			}
		} else {
			return data.PlannedUnits;
		}
	},

	// Special Helper functions to return proper Cost for Sheet Calcs
	mediaMathSheetWrapper: (name, value, data) => {
		if (value) {
			if (name === "PlannedUnits" || name === "Rate" || name === "RateType") {
				let dataValues;
				// Rate Type is required before any calculations can happen
				switch (name) {
					case "RateType":
						dataValues = {
							RateType: { value },
							PlannedUnits: { value: data.PlannedUnits },
							Rate: { value: data.Rate }
						};
						return MediaMath.fireSheetConversionMath(dataValues);
					case "PlannedUnits":
						dataValues = {
							RateType: { value: data.RateType },
							PlannedUnits: { value },
							Rate: { value: data.Rate }
						};
						return MediaMath.fireSheetConversionMath(dataValues);
					case "Rate":
						dataValues = {
							RateType: { value: data.RateType },
							PlannedUnits: { value: data.PlannedUnits },
							Rate: { value }
						};
						return MediaMath.fireSheetConversionMath(dataValues);
					default:
						return data.Cost;
				}
			} else {
				return data.Cost;
			}
		} else {
			return 0;
		}
	},

	fireSheetConversionMath: (dataValues) => {
		if (dataValues.RateType.value) {
			const formulaToCalc = MediaMath.getRateLineItem({ label: dataValues.RateType.value });
			const mediaMathFormula = Object.keys(formulaToCalc).length === 0 ? "0" : formulaToCalc[0].Formula;
			/* =========================== */

			const PlannedUnitValue = dataValues.PlannedUnits;
			const total = MediaMath.mediaMathCalc(mediaMathFormula, dataValues);
			return total;
		}
		return 0;
	},

	mathParser: (formula, values) => {
		return Parser.evaluate(formula, values);
	},

	performTableMath: (rowData) => {
		if (rowData.RateType) {
			const formulaToCalc = MediaMath.getRateLineItem({ label: rowData.RateType });
			const mediaMathFormula = Object.keys(formulaToCalc).length === 0 ? "0" : formulaToCalc[0].Formula;
			const totalCost = MediaMath.mathParser(mediaMathFormula, {
				PlannedUnits: rowData.PlannedUnits ? Number(rowData.PlannedUnits) : 0,
				Rate: rowData.Rate ? Number(rowData.Rate.replaceAll(",", "")) : 0
			});
			return totalCost || 0;
		}
		return 0;
	},

	determineIfUSCurrency: (contextTree, callback) => {
		contextTree.forEach((context) => {
			if (context.type === "country") {
				if (context.id === AppSDK.getContextId() && ["United States of America", "US"].includes(context.name)) {
					callback();
				}
			} else if (context.contexts) {
				MediaMath.determineIfUSCurrency(context.contexts, callback);
			}
		});
	}
};

export default MediaMath;
